import Model from '@/models/Model.js';

export default class Permission extends Model {
    static entity = 'permissions';

    static fields() {
        return {
            id: this.attr(null),
            name: this.attr(null),
            guard_name: this.attr(null),
            action: this.attr(null),
            subject: this.attr(null),

            ...super.fields(),

            created_at: this.string(''),
            updated_at: this.string(''),
        };
    }
}
